import React from 'react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const LeftArrowIcon = () => (
  <Icon tooltip="Back" iconObj={faArrowLeft} />
);

export default LeftArrowIcon;